###
  Permission editor
###

class INTENT.widgets.PermissionEditor

  @ATTR_NAME: "data-widget-permission-editor"

  fields: {}
  values: {}
  datasets: {}
  default_group:
    name: 'advertisers_view'
    value: null
    params: []
  wrapper: null
  new_permissions_state: no
  context: 'user'

  constructor: (@el) ->
    @s = @.constructor

    @fields = @el.data('permission-editor-fields')
    @values = @el.data('permission-editor-values')
    @datasets = @el.data('permission-editor-datasets')
    @wrapper = @el.find('[data-permission-editor-wrapper]').eq(0)

    if $('[data-form-role-edit]').length
      @context = 'role'

    for key, group of @values
      @add_input_group group

    @el.on 'click', '[data-permission-editor-remove]', (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      input_group = self.closest('[data-permission-editor-group]').eq(0)
      if input_group.length
        self.tooltip('destroy')
        input_group.find('select').destroySelect2()
        do input_group.remove

    @el.on 'click', '[data-permission-editor-add]', (e) =>
      e.preventDefault()
      @new_permissions_state = on
      self = $(e.currentTarget)
      if self.attr('disabled')
        return false
      @add_input_group @default_group
      do init_select2

    @el.on 'change', '[data-permission-editor-name-select]', (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      group_dom = self.closest('[data-permission-editor-group]').eq(0)
      index = group_dom.data 'permission-editor-group'
      results_dom = @el.find("[data-permission-editor-results='#{index}']").eq(0)
      @new_permissions_state = on

      group =
        name: self.val()
        value: null
        params: []

      #replace values and params block
      new_results_dom = @get_results_template index, group
      results_dom.find('select').destroySelect2()
      results_dom.replaceWith new_results_dom
      do init_select2

    @el.on 'change', '[data-permission-editor-value-select]', (e) =>
      e.preventDefault()
      self = $(e.target)
      group_dom = self.closest('[data-permission-editor-group]').eq(0)
      index = group_dom.data 'permission-editor-group'
      params_dom = @el.find("[data-permission-editor-params='#{index}']").eq(0)
      name_dom = @el.find("[data-permission-editor-name='#{index}'] [data-permission-editor-name-select]").eq(0)
      @new_permissions_state = on

      group =
        name: name_dom.val()
        value: self.val()
        params: []

      new_params_dom = @get_result_params_template index, group
      params_dom.find('select').destroySelect2()
      params_dom.replaceWith new_params_dom
      do init_select2

    # blacklist convert btn handler
    $(document).on 'click', '.white-list-convert-btn', (e) =>
      @permission_converter_handler e, 'convert_to_whitelist'

    # blacklist convert undo btn handler
    $(document).on 'click', '.white-list-convert-undo-btn', (e) =>
      @permission_converter_handler e, 'convert_to_blacklist'

  add_input_group: (group) ->
    index = @get_input_group_index()

    new_group = @get_input_group_template(index, group)
    last_group = @wrapper.find('[data-permission-editor-group]:last')
    if last_group.length
      last_group.after new_group
    else
      @wrapper.prepend new_group

  get_input_group_template: (index, group) ->
    if typeof group is 'undefined' or typeof @fields[group.name] is 'undefined'
      return ''

    name_html = @get_name_template index, group
    params_html = @get_results_template index, group

    """
    <tr class="permission-row" data-permission-editor-group="#{index}">
      #{name_html}
      #{params_html}
      <td class="remove-permission-icon-container">
        <i class="glyphicon glyphicon-remove remove-form-group-icon"
          title="#{__('admin.permissions.remove-permission-icon')}"
          data-permission-editor-remove
          data-widget-tooltip data-auto-init
        ></i>
      </td>
    </tr>
    """

  get_name_template: (index, group) ->
    selected_name = group.name if group
    options = {}
    for key, item of @fields
      options[key] = item.title

    """
    <td class="permission-names-container col-md-4" data-permission-editor-name="#{index}">
      <select class="input-xlarge permission-name select2-init"
              name="permissions[#{index}][name]"
              data-width="resolve"
              data-permission-editor-name-select
              data-escape-html="1"
      >
              #{@get_select_options_template(options, selected_name)}
      </select>
    </td>
    """

  get_results_template: (index, group) ->
    template = ''
    inputs = @fields[group.name].inputs if group

    if not inputs
      template = @get_result_enabled_template()
    else
      template += @get_result_template index, group

    """
    <td class="permission-params-and-values-container col-md-8" data-permission-editor-results="#{index}">
      #{template}
    </td>
    """

  get_result_template: (index, group) ->
    template = ''

    inputs = @fields[group.name].inputs if group and @fields[group.name]
    if not inputs
      return

    if inputs['value']
      template += @get_result_value_template index, group

    if inputs['params']
      template += @get_result_params_template index, group

    template

  get_result_enabled_template: () ->
    """
    <div class="col-md-12 permission-param-container">
      <div class="permission-params-label">
        <label></label>
      </div>
      <div class="permission-param-input-container">
        <div class="span8 permission-param-input">
          <i class="glyphicon glyphicon-ok"></i>
          #{__('admin.permissions.permission-available')}
        </div>
      </div>
    </div>
    """

  get_result_params_template: (index, group) ->
    inputs = @fields[group.name].inputs if group and @fields[group.name]
    input = inputs['params'] if inputs
    if not input
      return

    template = ''
    switch input.type
      when 'select'
        select_value = group.params
        select_options = input.values
        select_name = 'params'

        if (group.name in ['dataset_white', 'dataset_view']) and not select_options
          dataset = group.value
          if not dataset
            #by default set first of datasets
            for key of @datasets
              dataset = key
              break
          select_options = @datasets[dataset].fields if @datasets[dataset]

        select_settings =
          multiple: input.multiple
          tags: input.multiple and not select_options

        if input.ajax_url
          select_settings['ajax--url'] = input.ajax_url

        if input.attributes
          for attr of input.attributes
            select_settings[attr] = input.attributes[attr]

        template = @get_select_template index, select_name, select_options, select_value, select_settings
        if 'dataset_view' == group.name and !@new_permissions_state
          template = @append_blacklist_convert_btn template, group.value
      when 'text'
        input_name = 'params'
        input_value = group.params[0] if group.params
        template = @get_input_template index, input_name, input_value

    @get_result_item_wrapper index, 'params', input, template

  get_result_value_template: (index, group) ->
    inputs = @fields[group.name].inputs if group and @fields[group.name]
    input = inputs['value'] if inputs
    if not input
      return

    select_value = group.value
    select_options = input.values
    select_name = 'value'
    select_settings =
      multiple: input.multiple
      tags: input.multiple and not select_options

    template = @get_select_template index, select_name, select_options, select_value, select_settings
    @get_result_item_wrapper index, 'value', input, template


  get_result_item_wrapper: (index, block_name, input, inner_html) ->
    """
    <div class="col-md-12 permission-param-container" data-permission-editor-#{block_name}="#{index}">
        <div class="permission-params-label">
            <label>
                #{input.label}
            </label>
        </div>
        <div class="permission-param-input-container">
          #{inner_html}
        </div>
    </div>
    """

  get_select_template: (index, name, options_list, options_selected, settings = {}) ->
    if not settings.width
      settings.width = 'resolve'

    data_attr = ''
    for attr_name of settings
      attr_value = settings[attr_name]
      data_attr += "data-#{attr_name}=\"#{attr_value}\" "

    """
    <select
      name="permissions[#{index}][#{name}][]"
      class="#{if settings['ajax--url'] then 'select2-ajax-init' else 'select2-init'} input-xlarge outdate"
      #{data_attr}
      #{'multiple="multiple"' if settings.multiple}
      data-permission-editor-#{name}-select
      data-escape-html="1"
    >
      #{@get_select_options_template(options_list, options_selected)}
    </select>
    """

  get_select_options_template: (options_list, options_selected = []) ->
    if typeof options_selected != 'object'
      options_selected = [options_selected]

    options = ''

    if options_list
      for key, value of options_list
        id = key
        name = value
        if typeof value == 'object'
          id = value.id
          name = value.name

        if id in options_selected
          options += "<option value='#{id}' selected='selected'>#{escapeHtml(name)}</option>"
        else
          options += "<option value='#{id}'>#{escapeHtml(name)}</option>"
    else
      for key, value of options_selected
        id = value
        name = value
        if typeof value == 'object'
          id = value.id
          name = value.name

        options += "<option value='#{id}' selected='selected'>#{escapeHtml(name)}</option>"

    options

  get_input_template: (index, name, value = '') ->
    """
    <input
      name="permissions[#{index}][#{name}][]"
      class="form-control input-xlarge outdate"
      value="#{value}"
      data-permission-editor-#{name}-input
    >
    """

  get_input_group_index: ->
    index = 0
    while @el.find('[data-permission-editor-group="' + index + '"]').length > 0
        index++
    index

  append_blacklist_convert_btn: (template, dataset) ->
    html = "<button data-dataset-name='#{dataset}' class='white-list-convert-btn btn btn-primary btn-xs pull-right col-sm-6' style='margin-top:5px;'>#{__('convert_to_whitelist')}</button>"
    if template instanceof jQuery
      template.append $(html)
    else
      template + html

  append_blacklist_convert_undo_btn: (ctx, dataset) ->
    ctx.append $("<button data-dataset-name='#{dataset}' class='white-list-convert-undo-btn btn btn-danger btn-xs pull-right col-sm-6' style='margin-top:5px;'><i class='fa fa-undo'></i> #{__('undo_convert_to_whitelist')}</button>")

  permission_converter_handler: (e, mode = 'convert_to_whitelist') =>
    self = this
    e.preventDefault()
    btn = $(e.target)
    if 'convert_to_whitelist' == mode
        url = '/ajax/v2/permissions/datasets/convert_to_whitelist'
        permission = 'dataset_white'
        appendHandler = self.append_blacklist_convert_undo_btn
    else
        url = '/ajax/v2/permissions/datasets/convert_to_blacklist'
        permission = 'dataset_view'
        appendHandler = self.append_blacklist_convert_btn

    $.ajax
      url: url
      data:
        dataset: btn.data 'datasetName'
        entity_id: parseInt $("[data-form-#{self.context}-edit]").data('id')
        context: self.context
      method: 'post'
      beforeSend: ->
        window.aborting = on
        btn.showLoader()
    .done ->
      self.reload_permissions ->
        btn.hideLoader()
        converted = _.filter self.values, (group) ->
          return group.name == permission and group.value == btn.data('datasetName')

        if converted.length
          ctx = btn.parents 'tr'
          newCtx = $(self.get_input_group_template(self.get_input_group_index(), converted[0]))
          newCtx.find('.white-list-convert-btn').remove()
          appendHandler newCtx.find('.permission-param-input-container:last'), btn.data('datasetName')
          $(document).trigger 'permission_converted', {dataset: btn.data('datasetName')}
          ctx.replaceWith newCtx
        else
          btn.hideLoader()
          $(document).trigger 'permission_convert_error', {dataset: btn.data('datasetName')}
          INTENT.utils.Notify.error __('permission_was_not_changed')
    .fail ->
        btn.hideLoader()
        $(document).trigger 'permission_convert_error', {dataset: btn.data('datasetName')}
        INTENT.utils.Notify.error __('permission_was_not_changed')

  reload_permissions: (next) =>
    self = @
    $.get(window.location.href).done (res) ->
      pContainer = $(res).find('.permissions-table-container')
      if pContainer.length
        self.fields = pContainer.data('permission-editor-fields')
        self.values = pContainer.data('permission-editor-values')
        self.datasets = pContainer.data('permission-editor-datasets')
        next()
